export default {
translation: {
"time.s":"с",
"duration.seconds":"секунд",
"duration.days":"дней",
"duration.hours":"часов",
"duration.minutes":"минут",

"auth.login-title": "Вход",
"auth.recover-title":"Восстановление",
"auth.register-title":"Регистрация",
"auth.verify-title":"Подтверждение",
"auth.reset-title":"Сброс пароля",

"button-close": "Закрыть",
"button-reset": "Сбросить",
"button-save": "Сохранить",

"list-and": " и ",

"лет жизни_one": "{{count}} год жизни",
"лет жизни_few": "{{count}} года жизни",
"лет жизни_many": "{{count}} лет жизни",
"лет жизни_other": "{{count}} года жизни",

"price_month_one": "{{count}} месяц",
"price_month_few": "{{count}} месяца",
"price_month_many": "{{count}} месяцев",
"price_month_other": "{{count}} месяца",

"price_year_one": "{{count}} год",
"price_year_few": "{{count}} года",
"price_year_many": "{{count}} лет",
"price_year_other": "{{count}} года",

"price_day_one": "{{count}} день",
"price_day_few": "{{count}} дня",
"price_day_many": "{{count}} дней",
"price_day_other": "{{count}} дня",

"payment-gateway-moneta": "Оплата из РФ",
"payment-gateway-moneta-desc": "МИР, СБП",

"payment-gateway-finik": "Международная",
"payment-gateway-finik-desc": "VISA, СБП, QR Кыргызстан",

"audioplayer-listen":"прослушать",
"flow-warning-answer":"Пройдите",

"privacy-policy": 'Политика конфиденциальности',
"privacy-policy-url": 'https://nestarenie.expert/2024/04/18/1/',
"user-agreement": 'Пользовательское соглашение',
"user-agreement-url": 'https://nestarenie.expert/2024/04/18/2/',

"blood-test-preparation-url":"https://nestarenie.ru/podgotovka.html",
"chatbot-limit-part-1":"Осталось",
"chatbot-limit-part-2":"вопросов",
"chatbot-input-prompt":"Ваш вопрос (? для справки)",
"chatbot-mode-consultant":"Режим консультанта",
"chatbot-mode-expert":"Режим эксперта",
"chatbot-mode-kb-1":"База знаний, 1 ответ",
"chatbot-mode-kb-2":"База знаний, 2 ответа",
"chatbot-mode-kb-3":"База знаний, 3 ответа",
"chatbot-mode-na":"Доступно только при наличии подписки",

}
};
